import { DietaryRequirementType } from '@/api/dtos';
import RegistrationField from '@/components/RegistrationField';
import { StepContext } from '@/contexts/StepContext';
import { Grid, Paper, Typography } from '@mui/material';
import { Checkbox, Select, Text, ToggleButtonGroup } from '@ngt/forms';
import { Condition, ConditionMode } from '@ngt/forms-core';
import { FC } from 'react';

const requiresSpecialitySpecification = ({value}: any) => value.speciality == 15;
const requiresHeardAboutAsmSpecification = ({value}: any) => value.heardAboutAsm == 30;
const countryIsAustralia = ({value}: any) => value?.country?.toLowerCase() === "australia";
// const attendanceTypeInPerson = ({value}: any) => value.attendanceType === 1;

const parse: any = (inputValue: any) => 
    inputValue === 0 ?
        false :
        inputValue === 1 ?
            true :
            undefined

const convert: any = (fieldValue: any) => 
    fieldValue === false ?
        0 :
        fieldValue === true ?
            1 :
            undefined;

interface IEarlyBird{
    earlyBird?: boolean;
}

const RegistrationStepThree: FC<IEarlyBird> = ({earlyBird = false}) => {
    return (
        <StepContext.Provider value={3}>
            <Paper
                sx={{ p: 4, pt: 0, mt: { xs: 1, md: 3 } }}
            >
                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Institution"
                            propertyPath="institution"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={5}
                    >
                        <RegistrationField
                            label="Please tick if you are in your early/middle career in research"
                            propertyPath="earlyMidCareer"
                            component={Checkbox}
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Speciality"
                            propertyPath="speciality"
                            component={Select}
                            FormControlProps={{
                                variant: "standard"
                            }}
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >                    
                        <Condition
                            condition={requiresSpecialitySpecification}
                        >
                            <RegistrationField
                                label="Specify Other"
                                propertyPath="specialitySpec"
                                component={Text}
                                variant="standard"
                                disabled={earlyBird}
                            />
                        </Condition>
                    </Grid>
                </Grid>
                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={12}
                        mt={4}
                    >
                        <RegistrationField
                            label="Address"
                            propertyPath="address"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Suburb"
                            propertyPath="suburb"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Postcode"
                            propertyPath="postcode"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Country"
                            propertyPath="country"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <Condition
                            condition={countryIsAustralia}
                            subscription = {{
                                value: true
                            }}
                            mode={ConditionMode.Enable}
                        >
                            <RegistrationField
                                label="State / Territory"
                                propertyPath="state"
                                component={Select}
                                FormControlProps={{
                                    variant: "standard"
                                }}
                                disabled={earlyBird}
                            />
                        </Condition>
                    </Grid>
                </Grid>
                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Mobile Phone Number"
                            propertyPath="mobile"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Email"
                            propertyPath="email"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>


                <Grid
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Where did you hear about the BCT ASM?"
                            propertyPath="heardAboutAsm"
                            component={Select}
                            FormControlProps={{
                                variant: "standard"
                            }}
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >                    
                        <Condition
                            condition={requiresHeardAboutAsmSpecification}
                        >
                            <RegistrationField
                                label="Specify Other"
                                propertyPath="heardAboutAsmOther"
                                component={Text}
                                variant="standard"
                                disabled={earlyBird}
                            />
                        </Condition>
                    </Grid>
                </Grid>
                
                {/* <Condition
                    condition={attendanceTypeInPerson}
                    subscription = {{
                        value: true
                    }}
                    mode={ConditionMode.Show}
                > */}
                <Grid
                    container
                    columnSpacing={4}
                    
                >
                    <Grid 
                        item 
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        <RegistrationField
                            label="Dietary Requirement"
                            propertyPath="dietaryRequirement"
                            component={Select}
                            FormControlProps={{
                                variant: "standard"
                            }}
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid 
                        item 
                        xs={12}
                        md={6}
                        mt={2}
                    >                   
                        <Condition
                            condition={({value}) => value?.dietaryRequirement === DietaryRequirementType.SpecificFoodAllergy}
                            subscription = {{
                                value: true
                            }}
                            mode={ConditionMode.Enable}
                        >
                            <RegistrationField
                                label="Please enter any dietary requirements, including for any additional attendees"
                                propertyPath="dietaryRequirements"
                                component={Text}
                                variant="standard"
                                margin="normal"
                                disabled={earlyBird}
                            />
                        </Condition>
                    </Grid>
                </Grid>
                {/* </Condition>
                <Condition
                    condition={attendanceTypeInPerson}
                    subscription = {{
                        value: true
                    }}
                    mode={ConditionMode.Show}
                > */}
                    <Grid
                        container
                        columnSpacing={4}
                        mt={4}
                    >
                        <Grid item xs={12} md={8}><Typography>Do you require any disability access to the event?</Typography></Grid>
                        <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                            <RegistrationField
                                label="Do you require any disability access to the event?"
                                propertyPath="requiresDisabilityAccess"
                                component={ToggleButtonGroup}
                                sx={{margin:"normal"}}
                                disabled={earlyBird}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        columnSpacing={4}
                        mt={4}
                    >
                        <Grid item xs={12} md={8}><Typography>Do you require any visual or audio assistance at the event?</Typography></Grid>
                        <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                            <RegistrationField
                                label="Do you require any visual or audio assistance at the event?"
                                propertyPath="requiresAVAssistance"
                                component={ToggleButtonGroup}
                                sx={{margin:"normal"}}
                                disabled={earlyBird}
                            />
                        </Grid>
                    </Grid>
                {/* </Condition> */}
                <Grid
                    container
                    columnSpacing={4}
                    mt={4}
                >
                    <Grid item xs={12} md={8}><Typography>Do you agree to your name and contact details being included in the 2026 BCT ASM Delegate Listing?</Typography></Grid>
                    <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                        <RegistrationField
                            label="Do you agree to your name and contact details being included in the 2026 BCT ASM Delegate Listing?"
                            propertyPath="includeDetails"
                            component={ToggleButtonGroup}
                            sx={{margin:"normal"}}
                            parse={parse}
                            convert={convert}
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    columnSpacing={4}
                    mt={4}
                >
                    <Grid item xs={12} md={8}><Typography>Would you like to receive a certificate of attendance?</Typography></Grid>
                    <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                        <RegistrationField
                            label="Would you like to receive a certificate of attendance?"
                            propertyPath="receiveCertificate"
                            component={ToggleButtonGroup}
                            sx={{margin:"normal"}}
                            parse={parse}
                            convert={convert}
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </StepContext.Provider>
    )
}

export default RegistrationStepThree;